import React from 'react'
import { IData } from '../../../interfaces/table'
import SwitchComponent from '../../switch'

import { Container } from './styles'

type IProps = IData & {
  item: any
}

const Switch = ({ value, handler, item }: IProps) => (
  <Container>
    <SwitchComponent
      value={value}
      onClick={() => handler(item)}
      isDisabled={item.item.customer}
    />
  </Container>
)

export default Switch
